<template>
	<v-text-field
		v-model.trim="numbervin"
		:label="label"
		:placeholder="placeholder"
		:outlined="outlined"
		:dense="dense"
		:clearable="clearable"
		:rules="[rules.required]"
		:hide-details="hideDetails"
		@keyup.ctrl.90="defaultValue"
	></v-text-field>
</template>

<script>
import moment from 'moment'
export default {
	data: vm => ({
		defaultMode: false,
	}),

	props: {
		value: 			{ type: String, default: ''},
		label:  		{ type: String, default: "Номер авто або VIN-код"},
		placeholder:  	{ type: String, default: "Реєстраційний номер або VIN-код"},
		hint:  			{ type: String, default: null},
		persistentHint:	{ type: Boolean, default: false },
		readonly:		{ type: Boolean, default: false },
		clearable:		{ type: Boolean, default: false },
		outlined: 		{ type: Boolean, default: false },
		dense: 			{ type: Boolean, default: false },
		outlined: 		{ type: Boolean, default: false },
		prependIcon:  	{ type: String, default: null}, //"mdi-calendar
		hideDetails: 	{ type: [Boolean,String], default: false },
		rules:			{ type: [Array,Object], default: () => [] },
		defaultNumber:  { type: String, default: 'ab9999it'},
		defaultVin:  	{ type: String, default: 'WVGZZZCRZKD026937'},
	},

	computed: {
		numbervin: {
			get() 		{ return this.value },
			set(val) 	{ this.$emit('input', val) }
		},
	},

	methods: {
		defaultValue() {
			//console.log(this.$options.name, 'defaultNumberVin','params', this.params)

			this.defaultMode =! this.defaultMode;

			this.numbervin = this.defaultMode ? this.defaultNumber : this.defaultVin
		},
	},
}
</script>